<template>

	<div class="row">

		<div class="col-md-12">

			<h2 v-translate>Medicações pendentes</h2>

			<div class="table-responsive">

				<table class="table table-bordered table-striped table-condensed flip-content">

					<thead class="flip-content">

						<tr>

							<th class="col-time align-middle">
								<i class="fa fa-clock-o" aria-hidden="true"></i>
								<span v-translate>Horário programado</span>
							</th>

							<th class="col-time align-middle">
								<i class="fa fa-clock-o" aria-hidden="true"></i>
								<span v-translate>Horário ministrado</span>
							</th>

							<th class="align-middle">
								<i class="fa fa-user" aria-hidden="true"></i>
								<span v-translate>Aluno</span>
							</th>

							<th class="align-middle">
								<i class="fa fa-medkit" aria-hidden="true"></i>
								<span v-translate>Medicação e Dosagem</span>
							</th>

							<th class="align-middle">
								<i class="fa fa-heartbeat" aria-hidden="true"></i>
								<span v-translate>Motivo</span>
							</th>

						</tr>

					</thead>

					<tbody v-show="pendingList.list.length">

						<tr v-for="(medicine, index) in pendingList.list">

							<td class="prog align-middle" :class="{ 'font-red bold': getTimeDiff(medicine.hour) > 0 }">
								<i class="fa fa-exclamation-triangle" aria-hidden="true" v-if="getTimeDiff(medicine.hour) > 0" ></i>
								{{ medicine.hour | date('HH:mm', true) }}
							</td>

							<td class="align-middle">

								<form v-on:submit.prevent="saveMedicineHour(medicine.id, medicine.takenHour)" role="form">

									<div class="input-group" :class="{ 'has-error': errors.has(getTakenHourInputName(index)) }">

										<input type="text" class="form-control input-sm" :name="getTakenHourInputName(index)" v-model="medicine.takenHour" v-mask="'##:##'" v-validate="{ rules: { required: true, regex: /^([01]\d|2[0-3]):?([0-5]\d)$/ } }" :disabled="isBeforeDate()">

										<span class="input-group-btn">

											<button type="submit" class="btn btn-sm green" :disabled="errors.has(getTakenHourInputName(index)) || isBeforeDate()" v-translate>
												Salvar
											</button>

										</span>

									</div>

								</form>

							</td>

							<td class="align-middle">

								<img width="25px" height="25px" :src="medicine.student.photoURL" class="img-circle">

								<span>{{ medicine.student.name }}</span>

								<small class="font-grey-cascade display-block m-t-5">
									<span v-translate>Solicitado por</span>
									{{ medicine.responsible.name }}
								</small>

							</td>

							<td class="text-center align-middle">

								<span class="display-block m-b-10">{{ medicine.medicine }} - {{ medicine.dosage }}</span>

								<a class="btn btn-link btn-xs" target="_blank" :href="medicine.medicalPrescriptionURL" v-translate>
									Ver receita
								</a>

								<button type="button" class="btn btn-xs red-pink" @click="setReject(index)" v-translate>
									Rejeitar
								</button>

								<form v-on:submit.prevent="rejectionMedicine(medicine.id, medicine.rejectionReason, index)" class="m-t-10" role="form" v-show="medicine.reject">

									<div class="input-group">

										<input type="text" class="form-control input-sm" placeholder="Justifique..." v-model="medicine.rejectionReason" required>

										<span class="input-group-btn">

											<button type="submit" class="btn btn-default btn-sm green" v-translate>
												Justificar
											</button>

										</span>

									</div>

								</form>

							</td>

							<td class="text-center align-middle">{{ medicine.treatment }}</td>

						</tr>

					</tbody>

					<tfoot v-show="!pendingList.list.length">
						<tr>
							<td colspan="6" v-translate>Nenhuma medicação na data informada</td>
						</tr>
					</tfoot>

				</table>

			</div>

		</div>

	</div>

</template>

<script>

	import MedicinePending from './';
	export default MedicinePending;

</script>

<style lang="scss" scoped>

	.table {

		th {
			text-align: center;
			background-color: #32c5d2;
			color: #fff;
		}

		td {
			text-align: center;

			&.prog {
				font-size: 18px;
			}

		}

		.col-time {
			width: 145px;
		}

	}

	h2 {
		font-size: 20px;
	}

</style>



// WEBPACK FOOTER //
// medicine-pending.vue?5f7047e6